import React from 'react';
import { useStyletron } from 'baseui';
import { type OnChangeParams, type Option, Select, SIZE as SELECT_SIZE } from 'baseui/select';
import { LabelXSmall } from 'baseui/typography';
import { DEFAULT_SPEED_OPTIONS } from './constants';
import { getCompactSelectOverrides } from './select-overrides';
import type { SpeedSelectProps } from './types';
const getSelectOverrides = getCompactSelectOverrides('scale1600');
export const SpeedSelect = ({
  speed,
  onSpeedChange,
  options = DEFAULT_SPEED_OPTIONS
}: SpeedSelectProps) => {
  const [css, theme] = useStyletron();
  const selectOptions: Option[] = options.map(s => ({
    label: `${s}x`,
    id: s
  }));
  const selectedValue: Option[] = [{
    label: `${speed}x`,
    id: speed
  }];
  const handleChange = (params: OnChangeParams) => {
    const selected = (params.value as Option[])?.[0];
    if (selected?.id !== undefined) {
      onSpeedChange(Number(selected.id));
    }
  };
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale300
  })}>
      <LabelXSmall>Speed</LabelXSmall>
      <Select size={SELECT_SIZE.mini} options={selectOptions} value={selectedValue} onChange={handleChange} overrides={getSelectOverrides} clearable={false} searchable={false} />
    </div>;
};